function isISOString(input: string): boolean {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/;
  return isoDateRegex.test(input);
}

/**
 * Removes empty values from the JSON object and sorts the keys.
 * Designed to be used as the second argument to JSON.stringify.
 * @param key
 * @param value
 * @returns
 */
export const removeEmptyValuesAndSortKeys = (_, value) => {
  if (value == null) return undefined;
  else if (Array.isArray(value) && value.length === 0) return undefined;
  else if (Array.isArray(value)) return value;
  else if (typeof value === "string" && isISOString(value)) { return new Date(value).toISOString(); } else if (typeof value === "string" && value === "") return undefined;
  else if (typeof value === "object" && Object.keys(value).length === 0) { return undefined; } else if (typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((sorted, k) => {
        sorted[k] = value[k];
        return sorted;
      }, {});
  } else {
    return value;
  }
};

export const getCacheFriendlyInstruction = <I>(instruction: I): I => {
  return JSON.parse(JSON.stringify(instruction, removeEmptyValuesAndSortKeys));
};
